import { QueryObserverResult, RefetchOptions } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";
import { createContext } from "react";
import { ISelf } from "../hooks/useSelf";

export interface IAuthState {
  isLoading: boolean;
  isLogged: boolean;
  isAdmin: boolean | null;
}

export interface IAuthContext extends IAuthState {
  self: ISelf | null;
  toggleUserView: () => void;
  refetch: (
    options?: RefetchOptions,
  ) => Promise<QueryObserverResult<AxiosResponse<ISelf, any>, AxiosError<unknown, any>>>;
}

export const AuthContext = createContext<IAuthContext | null>(null);
